export const ReportConfig = {
  RT: 'RT',
  DP: 'DP',
  AT: 'AT',
  LIMIT_DISPATCH_REPORT: 100000,
  MAX_ROWS_DISPATCH_HISTORY_REPORT: 10000,
  MAX_ROWS_DISPATCH_REPORT: 10000,
  MAX_ROWS_WITHDRAW_REPORT: 10000,
  MAX_ROWS_SALE_NOTE_REPORT: 10000,
  MAX_ROWS_DEFAULT: 100000,
  ONE_WEEK: 6,
  ONE_MONTH: 29,
  SKU_STATUS: [
    { value: 'ENTREGADO PARCIALMENTE', text: 'Entregado parcialmente' },
    { value: 'ENTREGADO TOTALMENTE', text: 'Entregado totalmente' },
    { value: 'EN ALMACEN UBICADO', text: 'En almacén ubicado' },
    { value: 'EN ALMACEN SIN UBICAR', text: 'En almacén sin ubicar' },
    { value: 'EN PROCESO', text: 'En proceso' },
    { value: 'CANCELADO', text: 'Cancelado'},
    { value: 'EN DEVOLUCION', text: 'En devolución'},
    { value: 'EN DEVOLUCION A SELLER', text: 'En devolución a Seller'},
    { value: 'DEVOLUCION A SELLER', text: 'Devolución a Seller'}
  ],
  WITHDRAW_STATUS: [
    { value: 'PARTIALLY_DELIVERED', text: 'Entregado parcialmente' },
    { value: 'DELIVERED', text: 'Entregado totalmente' },
    { value: 'IN_WAREHOUSE_LOCATED', text: 'En almacén ubicado' },
    { value: 'IN_WAREHOUSE_WITHOUT_LOCATED', text: 'En almacén sin ubicar' },
    { value: 'IN_PROCESS', text: 'En proceso' },
    { value: 'CANCELLED', text: 'Cancelado'},
    { value: 'IN_RETURN', text: 'En devolución'},
    { value: 'IN_RETURN_SELLER', text: 'En devolución a Seller'},
    { value: 'RETURNED_SELLER', text: 'Devuelto a Seller'}
  ],
  DISPATCH_STATUS_IN_STORE_REPORT: [
    { value: 'Pendiente de picking', text: 'Pendiente de picking' },
    { value: 'Pendiente de despacho', text: 'Pendiente de despacho' },
    { value: 'Pendiente recepción', text: 'Pendiente de recepción' },
    { value: 'Pendiente de recojo Cliente', text: 'Pendiente de recojo cliente' },
    { value: 'Parcialmente entregada', text: 'Parcialmente entregada' },
    { value: 'Entregado al cliente', text: 'Entregado al cliente' },
    { value: 'Cancelado', text: 'Cancelado'},
    { value: 'En devolución', text: 'En devolución'},
    { value: 'En devolucion a Seller', text: 'En devolucion a Seller'}
  ],
  ARREAR_STATUS: [
    { value: 'ON_DATE', text: 'En fecha' },
    { value: 'LATE', text: 'Atrasado' }
  ],
  PRODUCT_TYPE: {
    ST: 'ST',
    SV: 'SV',
    FL: 'FL'
  },
  DISPATCH_STATUS: {
    PENDING_CUSTOMER_COLLECT: 'Pendiente de Recojo Cliente',
    PENDING_RECEPTION: 'Pendiente de Recepcion',
    PENDING_DISPATCH: 'Pendiente de Despacho',
    DISPATCHED: 'Viaje Despachado a Cliente',
    DELIVERED: 'Entregado'
  },
  CHANNELS: [
    { id: 'ecommerce', text: 'Ecommerce', default: true, active: true },
    { id: 'saleCompany', text: 'Venta Empresa', default: false, active: true },
    { id: 'storeQuote', text: 'Tienda Cotizacion', default: false, active: true },
    { id: 'marketplace', text: 'Marketplace', default: false, active: true },
    { id: 'oneStore', text: 'One Store', default: false, active: true },
    { id: 'customerStore', text: 'Venta Cliente', default: false, active: true },
    { id: 'AGORASHOP', text: 'Agora Shop', default: false, active: true },
    { id: 'JOKR', text: 'Venta Jokr', default: false, active: true },
    { id: 'GURU', text: 'Guru', default: false, active: false },
    { id: 'MERKAO', text: 'Merkao', default: false, active: true },
    { id: 'rediQuote', text: 'RediQuote', default: false, active: true },
    { id: 'INKAFARMA', text: 'Inkafarma', default: false, active: true },
    { id: 'ecommerceB2B', text: 'Ecommerce B2B', default: false, active: true }
  ],

  DASHBOARD_CHANNELS: [
    { id: 'ecommerce', text: 'ecommerce', default: true },
    { id: 'customerStore', text: 'customerStore', default: false },
    { id: 'marketplace', text: 'marketplace', default: false },
  ],
  DASHBOARD_COMPANIES:[
    { id: 'OE', text: 'OE', default: true },
    { id: 'PRO', text: 'PRO', default: true },
    { id: 'SPSA', text: 'SPSA', default: true },

  ],

  TYPE_MERCHANDISE: [
    { value: 'FOOD', text: 'FOOD' },
    { value: 'NONFOOD', text: 'NON FOOD' }
  ],

  PAYMENT_STATE: [
    { value: 'PAGADO', text: 'PAGADO' },
    { value: 'NO PAGADO', text: 'NO PAGADO' }
  ],

  FIELDS_REPORT: {
    CLIENT_GUIDE: {
      price: 'price'
    }
  }
};

export enum ModificationType {
  FREIGHT_MODIFY = 'Modificación de flete',
  PRICE_MODIFY = 'Modificación de precios',
  SALE_NOTE_EDIT_DELIVERY_DATE = 'Modificación de fecha de entrega',
  SALE_NOTE_EDIT_DELIVERY_ADDRESS = 'Modificación de dirección de entrega',
  SALE_NOTE_EDIT_WITHDRAW_PERSON = 'Persona que retira',

  SALE_NOTE_EDIT_DELIVERY_MODE = 'Modificación de modalidad de entrega',
  FREIGHT_DELETE = 'Eliminacion de flete',
  SALE_WITHOUT_STOCK = 'Venta sin stock'
}
